<template>
  <div class="list-page">
    <crumbs title="选择专利推荐">
      <template v-slot:close>
        <div class="close" @click="$router.go(-1)">
          <i class="el-icon-circle-close"></i>
        </div>
      </template>
    </crumbs>
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="4">
          <enumerate
            url="/api/achievement/getimproductfield"
            v-model="queryCondition.fieldId"
            placeholder="专业领域"
          />
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="queryCondition.publishDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="申请开始时间"
            end-placeholder="申请结束时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <region v-model="queryCondition.area" :isAll="true" />
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="queryCondition.userName"
            clearable
            placeholder="账号昵称"
          >
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model="queryCondition.keyWords"
            clearable
            placeholder="标题/专利号"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column prop="typeName" label="类型" width="90" align="center">
        </el-table-column>
        <el-table-column
          prop="applicationNumber"
          label="专利编号"
          width="160"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="专利名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="fieldName" label="专业领域" align="center">
        </el-table-column>
        <el-table-column
          prop="inventor"
          label="发明人"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="area"
          label="地区"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="账号昵称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="申请日期" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.applyDate.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.applyDate.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="auditStatusName"
          label="审核状态"
          width="90"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleChoice(scope.row)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "recommendPatent",
  data() {
    return {
      apiUrl: [],
      //查询条件
      queryCondition: {
        publishDate: [],
        area: [],
        fieldId: "",
        userName: "",
        auditStatus: 1,
        keyWords: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: []
    };
  },
  created() {
    const { method } = this.$route.query;
    let apiUrl;
    switch (method) {
      case "homepage":
        apiUrl = ["addHomepageRecommend", "getHomepagePat"];
        break;
    }
    this.apiUrl = apiUrl;
    this.loadList();
  },
  methods: {
    handleChoice(row) {
      const { id, name } = row;
      const { type, relationType } = this.$route.query;
      this.isLoading = true;
      this.$api("recommend", this.apiUrl[0], {
        relationId: id,
        name,
        type,
        relationType
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$router.go(-1);
        }
      });
    },
    //出来参数
    processParams() {
      let { keyWords, userName, pageIndex, pageSize, publishDate, area } =
          this.queryCondition,
        mixin = {
          fieldId: "",
          auditStatus: ""
        },
        [createBegin = "", createEnd = ""] = publishDate || [],
        [provinceCode = "", cityCode = "", districtCode = ""] = area || [];
      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        keyWords,
        userName,
        pageIndex,
        pageSize,
        ...mixin,
        createBegin,
        createEnd,
        provinceCode,
        cityCode,
        districtCode
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("recommend", this.apiUrl[1], this.processParams()).then(
        (res) => {
          this.isLoading = false;
          this.total = res.count;
          this.queryList = res.dataList;
        }
      );
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style></style>
